const pageNameKey = "zendeskContactUrl";

export const zendeskContactUrlEn = {
  [pageNameKey]: {
    failedGatewayOnboardingDescription:
      "I would like to connect an asset and I am facing some issues.\nPlease support me with connecting the asset with the underlying DSN address to the following gateway: [please enter the Gateway's hardware ID here].",
    connectionIdDescription:
      "The connection ID returned by the connection attempt is",
    connectionIdLabel: "Connection ID",
    failedSourceConnectionDescription:
      "I would like to connect an asset and I am facing some issues. Please support me with connecting the asset with the following DSN address to the gateway",
    onboardingSupportSubject: "Onboarding Support",
    blueprintSupportSubject: "Blueprint Creation Support",
    supportSubject: "Support Request",
    greeting: "Hello Tomorrow Things Support Team,",
    bodyIntro: "I need help.",
    userInfoHeader: "User Info",
    emailLabel: "Email",
    namespaceLabel: "Namespace",
    firstNameLabel: "First Name",
    lastNameLabel: "Last Name",
    describeIssue:
      "This is the issue I am facing: \n [...please describe the issue in detail here...]",
    blueprintBodyIntro:
      "I would like to get support for creating a blueprint for the following machine:",
    machineManufacturerLabel: "Machine Manufacturer",
    machineTypeLabel: "Machine Type",
    machineAmountLabel: "Amount of machines the blueprint will be used",
    platformMachineNameLabel: "Platform machine name",
    placeholder: "[please enter]",
    doNotChange: "(please do not change)",
    sourceDsnLabel: "Source DSN address",
  },
};

export const zendeskContactUrlPtBr = {
  [pageNameKey]: {
    failedGatewayOnboardingDescription:
      "Gostaria de conectar um ativo e estou enfrentando alguns problemas.\nPor favor, me ajude a conectar o ativo com o endereço DSN subjacente ao seguinte gateway: [informe aqui o ID de hardware do gateway].",
    connectionIdDescription:
      "O ID de conexão retornado pela tentativa de conexão é",
    connectionIdLabel: "ID da conexão",
    failedSourceConnectionDescription:
      "Gostaria de conectar um ativo e estou enfrentando alguns problemas. Por favor, me ajude a conectar o ativo ao gateway com o seguinte endereço DSN",
    onboardingSupportSubject: "Suporte de integração",
    blueprintSupportSubject: "Suporte à Criação de Blueprint",
    supportSubject: "Solicitação de suporte",
    greeting: "Olá, equipe de suporte da Tomorrow Things,",
    bodyIntro: "Preciso de ajuda.",
    userInfoHeader: "Informações do usuário",
    emailLabel: "E-mail",
    namespaceLabel: "Namespace",
    firstNameLabel: "Nome",
    lastNameLabel: "Sobrenome",
    describeIssue:
      "Este é o problema que estou enfrentando: \n [...descreva o problema em detalhes aqui...]",
    blueprintBodyIntro:
      "Gostaria de obter suporte para criar um blueprint para a seguinte máquina:",
    machineManufacturerLabel: "Fabricante da máquina",
    machineTypeLabel: "Tipo de máquina",
    machineAmountLabel: "Quantidade de máquinas em que o blueprint será usado",
    platformMachineNameLabel: "Nome da máquina da plataforma",
    placeholder: "[por favor, insira]",
    doNotChange: "(por favor, não altere)",
    sourceDsnLabel: "Endereço DSN da fonte de dados",
  },
};

export const zendeskContactUrlDe = {
  [pageNameKey]: {
    failedGatewayOnboardingDescription:
      "Ich möchte ein Asset verbinden und habe dabei Probleme. Bitte unterstützen Sie mich beim Verbinden des Assets mit der unterliegenden Quell-DSN-Adresse zum Gateway: [bitte tragen Sie die Hardware-ID hier ein].",
    connectionIdDescription: "Die Connection-ID ist",
    connectionIdLabel: "Connection-ID",
    failedSourceConnectionDescription:
      "Ich möchte ein Asset verbinden und habe dabei Probleme. Bitte unterstützen Sie mich beim Verbinden des Assets mit der folgenden Quell-DSN-Adresse zum Gateway",
    onboardingSupportSubject: "Onboarding-Unterstützung",
    blueprintSupportSubject: "Blueprint-Erstellung Unterstützung",
    supportSubject: "Supportanfrage",
    greeting: "Hallo Tomorrow Things Support-Team,",
    bodyIntro: "Ich benötige Hilfe.",
    userInfoHeader: "Benutzerdaten",
    emailLabel: "E-Mail",
    namespaceLabel: "Namespace",
    firstNameLabel: "Vorname",
    lastNameLabel: "Nachname",
    describeIssue:
      "Dies ist das Problem, das ich habe: \n [...bitte beschreiben Sie das Problem hier im Detail...]",
    blueprintBodyIntro:
      "Ich möchte Unterstützung bei der Erstellung eines Blueprints für die folgende Maschine erhalten:",
    machineManufacturerLabel: "Maschinenhersteller",
    machineTypeLabel: "Maschinentyp",
    machineAmountLabel:
      "Anzahl der Maschinen, für die der Blueprint verwendet wird",
    platformMachineNameLabel: "Plattform-Maschinenname",
    sourceDsnLabel: "Plattform-Quell-DSN-Adresse",
    placeholder: "[bitte eintragen]",
    doNotChange: "(bitte nicht ändern)",
  },
};

export const zendeskContactUrlZhHans = {
  [pageNameKey]: {
    failedGatewayOnboardingDescription:
      "我想连接一个资产，但遇到了一些问题。请协助我使用其底层 DSN 地址将资产连接到以下网关： [请在此处输入网关的硬件 ID]。",
    connectionIdDescription: "连接尝试返回的连接 ID 是",
    connectionIdLabel: "连接 ID",
    failedSourceConnectionDescription:
      "我想连接一个资产，但遇到了一些问题。请协助我使用以下 DSN 地址将资产连接到网关：",
    onboardingSupportSubject: "入门支持",
    blueprintSupportSubject: "蓝图创建支持",
    supportSubject: "支持请求",
    greeting: "您好，Tomorrow Things 支持团队：",
    bodyIntro: "我需要帮助。",
    userInfoHeader: "用户信息",
    emailLabel: "电子邮件",
    namespaceLabel: "命名空间",
    firstNameLabel: "名字",
    lastNameLabel: "姓氏",
    describeIssue: "这是我遇到的问题： \n [...请在此详细描述问题...]",
    blueprintBodyIntro: "我想获得支持，以为以下机器创建蓝图：",
    machineManufacturerLabel: "机器制造商",
    machineTypeLabel: "机器类型",
    machineAmountLabel: "该蓝图将用于的机器数量",
    platformMachineNameLabel: "平台机器名称",
    sourceDsnLabel: "平台源 DSN 地址",
    placeholder: "[请输入]",
    doNotChange: "(请勿更改)",
  },
};

export const zendeskContactUrlIt = {
  [pageNameKey]: {
    failedGatewayOnboardingDescription:
      "Vorrei collegare un dispositivo e sto riscontrando alcuni problemi.\nAiutatemi a collegare il dispositivo, con il relativo indirizzo DSN, al seguente gateway: [inserire qui l'ID hardware del gateway].",
    connectionIdDescription:
      "L'ID connessione restituito dal tentativo di connessione è",
    connectionIdLabel: "ID connessione",
    failedSourceConnectionDescription:
      "Vorrei collegare un dispositivo e sto riscontrando alcuni problemi. Aiutatemi a collegare il dispositivo, con il seguente indirizzo DSN, al gateway",
    onboardingSupportSubject: "Supporto onboarding",
    blueprintSupportSubject: "Supporto creazione Blueprint",
    supportSubject: "Richiesta di supporto",
    greeting: "Ciao team di supporto Tomorrow Things,",
    bodyIntro: "Ho bisogno di aiuto.",
    userInfoHeader: "Informazioni utente",
    emailLabel: "Email",
    namespaceLabel: "Namespace",
    firstNameLabel: "Nome",
    lastNameLabel: "Cognome",
    describeIssue:
      "Questo è il problema che sto riscontrando:\n [...descrivere qui il problema nel dettaglio...]",
    blueprintBodyIntro:
      "Vorrei ricevere supporto per creare un Blueprint per la seguente macchina:",
    machineManufacturerLabel: "Produttore macchina",
    machineTypeLabel: "Tipo macchina",
    machineAmountLabel: "Numero di macchine su cui verrà usato il Blueprint",
    platformMachineNameLabel: "Nome macchina in piattaforma",
    placeholder: "[inserire]",
    doNotChange: "(non modificare)",
    sourceDsnLabel: "Indirizzo DSN sorgente",
  },
};

export const zendeskContactUrlEs = {
  [pageNameKey]: {
    failedGatewayOnboardingDescription:
      "Me gustaría conectar un activo y estoy teniendo algunos problemas.\nPor favor, ayúdenme a conectar el activo, con la dirección DSN asociada, al siguiente gateway: [introduce aquí el ID de hardware del gateway].",
    connectionIdDescription:
      "El ID de conexión devuelto por el intento de conexión es",
    connectionIdLabel: "ID de conexión",
    failedSourceConnectionDescription:
      "Me gustaría conectar un activo y estoy teniendo algunos problemas. Por favor, ayúdenme a conectar el activo, con la siguiente dirección DSN, al gateway",
    onboardingSupportSubject: "Soporte de onboarding",
    blueprintSupportSubject: "Soporte para creación de blueprint",
    supportSubject: "Solicitud de soporte",
    greeting: "Hola, equipo de soporte de Tomorrow Things:",
    bodyIntro: "Necesito ayuda.",
    userInfoHeader: "Información del usuario",
    emailLabel: "Correo electrónico",
    namespaceLabel: "Namespace",
    firstNameLabel: "Nombre",
    lastNameLabel: "Apellido",
    describeIssue:
      "Este es el problema que estoy teniendo:\n [...describe el problema en detalle aquí...]",
    blueprintBodyIntro:
      "Me gustaría recibir ayuda para crear un blueprint para la siguiente máquina:",
    machineManufacturerLabel: "Fabricante de la máquina",
    machineTypeLabel: "Tipo de máquina",
    machineAmountLabel: "Cantidad de máquinas en las que se usará el blueprint",
    platformMachineNameLabel: "Nombre de máquina en la plataforma",
    placeholder: "[introducir]",
    doNotChange: "(no cambiar)",
    sourceDsnLabel: "Dirección DSN de la fuente",
  },
};

export const zendeskContactUrlNl = {
  [pageNameKey]: {
    failedGatewayOnboardingDescription:
      "Ik wil een asset verbinden en ondervind problemen.\nHelp mij de asset via het onderliggende DSN-adres te verbinden met de volgende gateway: [vul hier de hardware-ID van de gateway in].",
    connectionIdDescription:
      "De verbindingspoging geeft deze verbindings-ID terug:",
    connectionIdLabel: "Verbindings-ID",
    failedSourceConnectionDescription:
      "Ik wil een asset verbinden en ondervind problemen. Help mij de asset via het volgende DSN-adres met de gateway te verbinden",
    onboardingSupportSubject: "Ondersteuning bij onboarding",
    blueprintSupportSubject: "Ondersteuning bij het maken van een blueprint",
    supportSubject: "Ondersteuningsverzoek",
    greeting: "Hallo, team van Tomorrow Things Support,",
    bodyIntro: "Ik heb hulp nodig.",
    userInfoHeader: "Gebruikersgegevens",
    emailLabel: "E-mailadres",
    namespaceLabel: "Namespace",
    firstNameLabel: "Voornaam",
    lastNameLabel: "Achternaam",
    describeIssue:
      "Dit is het probleem dat ik ondervind: \n [...beschrijf het probleem hier in detail...]",
    blueprintBodyIntro:
      "Ik wil ondersteuning bij het maken van een blueprint voor de volgende machine:",
    machineManufacturerLabel: "Machinefabrikant",
    machineTypeLabel: "Machinetype",
    machineAmountLabel: "Aantal machines waarvoor de blueprint wordt gebruikt",
    platformMachineNameLabel: "Machinenaam op het platform",
    placeholder: "[vul hier in]",
    doNotChange: "(niet wijzigen)",
    sourceDsnLabel: "Bron-DSN-adres",
  },
};

export const zendeskContactUrlTr = {
  [pageNameKey]: {
    blueprintBodyIntro:
      "Aşağıdaki makine için plan oluşturma konusunda destek almak istiyorum:",
    blueprintSupportSubject: "Plan Oluşturma Desteği",
    bodyIntro: "Yardıma ihtiyacım var.",
    connectionIdDescription:
      "Bağlantı denemesi tarafından döndürülen bağlantı kimliği",
    connectionIdLabel: "Bağlantı Kimliği",
    describeIssue:
      "Karşılaştığım sorun şu: \n [...lütfen sorunu burada ayrıntılı olarak açıklayın...]",
    doNotChange: "(lütfen değiştirmeyin)",
    emailLabel: "E-posta",
    failedGatewayOnboardingDescription:
      "Bir varlığı bağlamak istiyorum ve bazı sorunlarla karşılaşıyorum.\nLütfen varlığı temel DSN adresiyle aşağıdaki ağ geçidine bağlama konusunda bana destek olun: [lütfen Ağ Geçidinin donanım kimliğini buraya girin].",
    failedSourceConnectionDescription:
      "Bir varlığı bağlamak istiyorum ve bazı sorunlarla karşılaşıyorum. Lütfen aşağıdaki DSN adresine sahip varlığın ağ geçidine bağlanması konusunda bana destek olun",
    firstNameLabel: "İlk adı",
    greeting: "Merhaba Tomorrow Things Destek Ekibi,",
    lastNameLabel: "Soy isim",
    machineAmountLabel: "Planın kullanılacağı makine miktarı",
    machineManufacturerLabel: "Makine Üreticisi",
    machineTypeLabel: "Makine Tipi",
    namespaceLabel: "Ad alanı",
    onboardingSupportSubject: "İlk Katılım Desteği",
    placeholder: "[lütfen girin]",
    platformMachineNameLabel: "Platform makine adı",
    sourceDsnLabel: "Kaynak DSN adresi",
    supportSubject: "Destek Talebi",
    userInfoHeader: "Kullanıcı Bilgileri",
  },
};
